export default __webpack_public_path__ + "static/img5-a68230e082321321bd46116edecd7b66.jpg";